import { EuiIcon, EuiText } from "@elastic/eui";
import React from "react";

import { CategoryScreen, Screen } from "../../../utils/types";
import { ScreensSummaryItem } from "./ScreensSummaryItem";

export const ScreensSummary = ({
    openModal,
    screens,
    screenOptions,
}: {
    openModal: () => void;
    screens: CategoryScreen[];
    screenOptions: Screen[];
}) => {
    return (
        <div onClick={openModal} style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
            <>
                <div style={{ display: "block" }}>
                    {screens.length > 0 ? (
                        screens.map((screen) => {
                            const option = screenOptions.find((screenOption) => screenOption.id === screen.screen_id);
                            return <ScreensSummaryItem key={screen.screen_id} screen={screen} option={option} />;
                        })
                    ) : (
                        <EuiText color="subdued">No screens assigned</EuiText>
                    )}
                </div>
            </>
            <>
                <EuiIcon type="pencil" color="primary" style={{ marginLeft: "1rem" }} />
            </>
        </div>
    );
};
